import React from 'react'
import S3Upload from './s3Upload'

export interface S3Response {
  signedUrl: string
  publicUrl: string
  filename: string
  fileKey: string
}

interface ReactS3UploaderProps {
  className?: string
  signingUrl?: string
  getSignedUrl?: (
    file: File,
    callback: (params: S3Response) => void,
  ) => Promise<void> | void
  preprocess?: (file: File, next: (file: File) => void) => void
  onSignedUrl?: (signingServerResponse: any) => void
  onProgress?: (percent: number, message: string, file: File) => void
  onFinish?: (signResult: any, file: any) => void
  onError?: (message: string) => void
  signingUrlMethod?: string
  signingUrlHeaders?: Record<string, string> | (() => Record<string, string>)
  signingUrlQueryParams?:
    | Record<string, string>
    | (() => Record<string, string>)
  signingUrlWithCredentials?: boolean
  uploadRequestHeaders?: Record<string, string>
  contentDisposition?: string
  server?: string
  scrubFilename?: (filename: string) => string
  s3path?: string
  inputRef?: React.RefObject<HTMLInputElement>
  autoUpload?: boolean
  [key: string]: any
}

const clearInputFile = (f: HTMLInputElement) => {
  if (f.value) {
    try {
      f.value = '' // for IE11, latest Chrome/Firefox/Opera...
    } catch (err) {}
    if (f.value) {
      // for IE5 ~ IE10
      const form = document.createElement('form')
      const parentNode = f.parentNode
      const ref = f.nextSibling
      form.appendChild(f)
      form.reset()
      parentNode?.insertBefore(f, ref)
    }
  }
}

const ReactS3Uploader: React.FC<ReactS3UploaderProps> = ({
  signingUrl,
  className,
  getSignedUrl,
  preprocess = (file, next) => {
    next(file)
  },
  onSignedUrl = (signingServerResponse) => {},
  onProgress = (percent, message, file) => {},
  onFinish = (signResult) => {},
  onError = (message) => {},
  signingUrlMethod = 'GET',
  signingUrlHeaders,
  signingUrlQueryParams,
  signingUrlWithCredentials,
  uploadRequestHeaders,
  contentDisposition,
  server = '',
  scrubFilename = (filename) => filename.replace(/[^\w\d_\-\.]+/gi, ''),
  s3path = '',
  autoUpload = true,
  inputRef,
  ...props
}) => {
  const [myUploader, setMyUploader] = React.useState<any>(null)

  const uploadFile = () => {
    const uploader = new S3Upload({
      fileElement: inputRef?.current,
      signingUrl,
      getSignedUrl,
      preprocess,
      onSignedUrl,
      onProgress,
      onFinishS3Put: onFinish,
      onError,
      signingUrlMethod,
      signingUrlHeaders,
      signingUrlQueryParams,
      signingUrlWithCredentials,
      uploadRequestHeaders,
      contentDisposition,
      server,
      scrubFilename,
      s3path,
    })
    setMyUploader(uploader)
  }

  const abort = () => {
    if (myUploader) {
      myUploader.abortUpload()
    }
  }

  const clear = () => {
    if (inputRef?.current) {
      abort()
      clearInputFile(inputRef.current)
    }
  }

  const inputProps = {
    type: 'file',
    onChange: autoUpload ? uploadFile : undefined,
    ...props,
  }

  return <input className={className} {...inputProps} />
}

export default ReactS3Uploader
